module.exports = __webpack_public_path__ + "img/20180815_150347_078.7fc0195e.jpg";